import { Loader2, ShieldCheck } from 'lucide-react';
import { useEffect, useState } from 'react';

import { getConfig } from '@/shared/config';

/**
 * Pantalla de carga mientras `processes/auth/use-hidratar-sesion` decide si
 * hay sesion previa (refresh cookie HttpOnly + GET /auth/me). Se muestra a
 * pantalla completa antes de que el router pinte cualquier ruta, para evitar
 * el flash de `/login` cuando en realidad el usuario sigue autenticado.
 *
 * Tras 1.5s sin terminar, se anuncia un mensaje secundario para no parecer
 * un freeze. Toda la animacion la reduce el `@media prefers-reduced-motion`
 * de `globals.css`.
 */
export function AuthHydrationSplash() {
  const { appName } = getConfig();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setShowFallback(true), 1500);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div
      data-testid="auth-hydration-splash"
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6"
    >
      <div className="flex animate-in fade-in items-center gap-3 duration-200">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <ShieldCheck aria-hidden="true" className="size-5" />
        </div>
        <p className="text-base font-semibold tracking-tight">{appName}</p>
      </div>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 aria-hidden="true" className="size-4 animate-spin" />
        <span>{showFallback ? 'Verificando su sesión…' : 'Cargando…'}</span>
      </div>
    </div>
  );
}
